import { Link } from 'react-router-dom';

const Logo = (props: { url?: string; size?: string; fontSize?: string }) => {
    const { url = '/', size = '40px' } = props;
    return (
        <div className='w-full flex items-center justify-center '>
            <Link
                to={url}
                style={{ width: size, height: size }}>
                <img
                    className='self-center'
                    width={size}
                    height={size}
                    alt='ASM'
                    src='https://i.imgur.com/CsLPYyV.png'
                    referrerPolicy='no-referrer'
                    crossOrigin='anonymous'
                    onError={(e) => {
                        e.currentTarget.style.display = 'none';
                    }}
                />
            </Link>
        </div>
    );
};

export default Logo;
